<template>
  <div class="buttons is-right">

    <button
      class="button is-outlined is-danger"
      v-if="$auth.check(['admin', 'superadmin']) && formId"
      @click.prevent="$emit('delete-clicked')"
    >Delete</button>

    <approve-button
      v-if="formStatus === 1"
      @approved="$emit('approve-clicked')"
    />

    <button
      class="button is-primary"
      v-if="formStatus === 0"
      @click.prevent="$emit('submit-clicked')"
    >Submit</button>

    <button
      :class="['button', changed ? 'is-warning' : 'is-primary is-outlined']"
      @click.prevent="$emit('save-clicked')"
    >Save</button>

  </div>
</template>

<script>
import ApproveButton from '@/components/ApproveButton'

export default {
  name: 'FormButtons',
  components: {
    ApproveButton
  },
  props: ['changed', 'formId', 'formStatus'],
  data () {
    return {}
  }
}
</script>
